
























































import { defineComponent, computed, watch } from "@vue/composition-api";
import { enrollState, sensor } from "@/store";

export default defineComponent({
    emits: ['closed'],
    props: { imgSrc: { type: String, default: "" } },
    setup(props, { emit }) {
        const visible = computed(() => enrollState.currentStep !== "idle");

        const title = computed(() => {
            switch (enrollState.currentStep) {
                case "preparing":
                    return "Preparing"
                case "enrolling":
                    return "Searching";
                case "configuring":
                    return "Configuring";
                case "success":
                    return "Success";
                case "timeout":
                    return "Timeout";
                case "failed":
                    return "Failed";
                default:
                    return "";
            }
        });

        const message = computed(() => {
            switch (enrollState.currentStep) {
                case "preparing": return "Preparing enrollment, please wait.";
                case "enrolling": return "Ready to enroll!";
                case "configuring": return "Configuring device...";
                case "success": return "Device added successfully.";
                case "timeout": return "Device pairing timed out.";
                case "failed": return "Device pairing failed.";
                default: return "";
            }
        });

        const isPreparing = computed(() => enrollState.currentStep === "preparing");

        const isConfiguring = computed(() => enrollState.currentStep === "configuring");

        const isLoading = computed(() =>
            ["enrolling", "configuring"].includes(enrollState.currentStep)
        );

        const isCountdown = computed(() =>
            ["preparing", "enrolling", "configuring"].includes(enrollState.currentStep)
        );

        const isResult = computed(() =>
            ["success", "timeout", "failed"].includes(enrollState.currentStep)
        );

        const formattedTime = computed(() => {
            const total = enrollState.countdown;
            return total >= 60
                ? `${Math.floor(total / 60)}m ${total % 60}s`
                : `${total}s`;
        });

        function reset() {
            enrollState.reset();
            sensor.GetData();
            emit('closed');
        }

        watch(
            () => enrollState.currentStep,
            (newVal, oldVal) => {
                if (newVal === "success" && oldVal !== "success") {

                    sensor.GetData();

                    setTimeout(() => {
                        enrollState.reset(); // sets currentStep = "idle"
                    }, 10000);
                }
            }
        );

        return {
            visible,
            title,
            message,
            isPreparing,
            isConfiguring,
            isLoading,
            isCountdown,
            formattedTime,
            isResult,
            reset
        };
    },
});
